// export const CONTRACT_ADDRESS = "0x59C5Ad1Ff23E595Cda53D6cDCB71a22AFF79F24D"; //main
export const CONTRACT_ADDRESS = "0xDAC2195dDCbe4cd6751eCeDc30Ba00CE95fee8d7"; //testing
